import type { CSSProperties } from 'react';
import StepCurrentIconSvg from '../../assets/icons/step_current.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const StepCurrentIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <StepCurrentIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default StepCurrentIcon;
